const BASE_URL = process.env.B2C_BASE_URL;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const POLICY = process.env.B2C_CHANGEPASSWORD_POLICY;
const REDIRECT_URI = encodeURIComponent(window.location.origin);
const SCOPE = 'openid';
const RESPONSE_TYPE = 'id_token';
const NONCE = 'defaultNonce';

export const generateChangePasswordLink = () => {
  return `${BASE_URL}?p=${POLICY}&client_id=${CLIENT_ID}&nonce=${NONCE}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}&response_type=${RESPONSE_TYPE}`;
};
